import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import $ from 'jquery'
import Message from '../utils/messages/message'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import InputText from '../utils/form/inputText'
import SelectInput from '../utils/form/selectInput'
import HttpRequests from '../api/httpRequests'
import '../features/newBehaviorArea/newBehaviorArea.css'

function NewBehaviorArea() {
  let history = useHistory()
  const [loading, setLoading] = useState(true)
  const [msgType, setMsgType] = useState('')
  const [clients, setClients] = useState(null)

  const listClients = async () => {
    $('.preloader').show()
    try {
      const response = await HttpRequests.listClients()
      setClients(response.data.data)
      setLoading(false)
    } catch {
      setMsgType('insert-failed')
      history.push('/error_500')
    } finally {
      $('.preloader').delay('500').fadeOut(1000)
    }
  }

  useEffect(() => {
    window.$('.sort-ordering-select-no-search').selectpicker()
    if (loading === true) {
      listClients()
    }
  })

  if (loading === false) {
    return (
      <>
        <Formik
          initialValues={{
            name: '',
            status: 'active',
            client: ''
          }}
          validationSchema={Yup.object({
            name: Yup.string()
              .min(2, 'Deve ter entre 2 e 80 caracteres')
              .max(80, 'Deve ter entre 2 e 80 caracteres')
              .required('Campo obrigatório'),
            client: Yup.string().required('Campo obrigatório'),
            status: Yup.string().required('Campo obrigatório')
          })}
          onSubmit={async (values, { setSubmitting }) => {
            try {
              $('.preloader').show()
              await HttpRequests.createBehaviorArea({
                name: values.name,
                status: values.status,
                client: values.client
              })
              setSubmitting(false)
              setMsgType('insert-successful')
              history.push('/behavior-area')
            } catch (error) {
              switch (error.response.status) {
                case 401:
                  setMsgType('401')
                  break

                case 403:
                  setMsgType('403')
                  break

                case 406:
                  setMsgType('406')
                  break

                case 409:
                  setMsgType('409')
                  break

                default:
                  setMsgType('500')
              }

              window.scrollTo(0, 0)
            } finally {
              $('.preloader').delay('500').fadeOut(1000)
            }
          }}
        >
          <Form>
            <div className='row mt-5'>
              <div className='col-lg-12'>
                <Message msgType={msgType} />
                <div className='card-box-shared'>
                  <div className='card-box-shared-title'>
                    <h3 className='widget-title'>
                      Cadastrar Área de Comportamento
                    </h3>
                  </div>
                  <div className='card-box-shared-body'>
                    <div className='user-form'>
                      <div className='contact-form-action'>
                        <div className='row'>
                          <div className='col-lg-4 col-sm-4'>
                            <InputText
                              label='Área de Comportamento'
                              name='name'
                              type='text'
                              icon=''
                            />
                          </div>
                          <div className='col-lg-4 col-sm-4'>
                            <SelectInput
                              label='Cliente'
                              name='client'
                              className='sort-ordering-select-no-search'
                            >
                              <option value=''>Selecione</option>
                              {clients.map(function (client) {
                                return (
                                  <option
                                    value={client.uuid}
                                    key={`${client.uuid}-${Math.random()
                                      .toString(36)
                                      .slice(2)}`}
                                  >
                                    {client.name}
                                  </option>
                                )
                              })}
                            </SelectInput>
                          </div>
                          <div className='col-lg-4 col-sm-4'>
                            <SelectInput
                              label='Status'
                              name='status'
                              className='sort-ordering-select-no-search'
                            >
                              <option value='active'>Ativo</option>
                              <option value='inactive'>Inativo</option>
                            </SelectInput>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-lg-12 '>
                <div className='new-group-action-buttons'>
                  <button className='theme-btn' type='submit'>
                    Cadastrar
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </Formik>
      </>
    )
  }
  return <div></div>
}

export default NewBehaviorArea
